module.exports = __webpack_public_path__ + "static/media/chatgpt-library-logo.bf222a64.png";